// detects if an element is partially visible on the screen
const isScrolledIntoView = (el) => {
  var rect = el.getBoundingClientRect()
  var elemTop = rect.top
  var elemBottom = rect.bottom
  var isVisible = elemTop < window.innerHeight && elemBottom >= 0
  return isVisible
}

export default isScrolledIntoView